<script>
	import IFTAInput from "../utils/iftainput.svelte";
	import CreditCard from "../utils/CreditCard.svelte";
	import Payment from "payment";


	export let cc_number = ""; 
	export let cc_name = "";
	export let cc_cvc = ""; 
	export let cc_expiry = "";
	export let is_cc_number_valid = undefined;
	export let is_cc_cvc_valid = undefined;
	export let is_cc_expiry_valid = undefined;
	export let is_new = true;


	let validate_cc_number = () => {
        if (is_new) {
            is_cc_number_valid = Payment.fns.validateCardNumber(cc_number);
            return is_cc_number_valid;
        } else {
            is_cc_number_valid = cc_number.toString().length > 0 ? true : false;
            return true;
        }
	}
	let validate_cc_expiry = () => {
		is_cc_expiry_valid = (cc_expiry.match(/([0-9]{2})\/([0-9]{2})/) ?? false) && Payment.fns.validateCardExpiry(cc_expiry);
		return is_cc_expiry_valid;
	}
	let validate_cc_cvc = () => {
        if (is_new) {
            is_cc_cvc_valid = cc_cvc.match(/^[0-9]{3,4}$/) ?? false;
            return is_cc_cvc_valid;
        } else {
            is_cc_cvc_valid = cc_cvc.toString().length > 0 ? true : false;
            return true;
        }
	}

	let handle_expiry = (evt) => {
			if (cc_expiry.length === 2) {
					if (evt.inputType !== 'deleteContentBackward')
							cc_expiry = cc_expiry + '/';
			}
			else {
					if (cc_expiry.length === 3 && cc_expiry.charAt(2) !== '/')
							cc_expiry = cc_expiry.slice(0, 2) + '/' + cc_expiry.slice(2);
			}
			validate_cc_expiry();
	}

	let focused_field = "number";
</script>

<div class="creditcardcontent">
	<div class="ccpreviewholder">
			<CreditCard
					number="{cc_number}"
					name="{cc_name}"
					cvc="{cc_cvc}"
					expiry="{cc_expiry}"
					preview="{true}"
					bind:focused="{focused_field}"
			/>
	</div>
	<div class="ff formrow">
			<div class="ff cc-name">
					<IFTAInput
							type="text"
							label="Cardholder Name"
							placeholder="John C. Cardholder"
							bind:value={cc_name}
					/>
			</div>
	
	</div>
	<div class="ff formrow">
			<div class="ff cc-number">
					<IFTAInput
							type="number"
							label="Card Number"
							maxlength="16"
							placeholder="0000 0000 0000 0000"
							bind:value={cc_number}
							bind:change_function={validate_cc_number}
							bind:validation_function={validate_cc_number}
							show_error={is_cc_number_valid === false}
							error_text={'Card number is invalid.'}
					/>
			</div>
			<div class="ff cc-expiry">
					<IFTAInput
							type="number"
							label="Expiration Date"
							maxlength="5"
							placeholder="MM/YY"
							bind:value={cc_expiry}
							bind:change_function={handle_expiry}
							bind:validation_function={validate_cc_expiry}
							show_error={is_cc_expiry_valid === false}
							error_text={'Expiration date is invalid.'}
					/>
			</div>
			<div class="ff cc-cvc">
					<IFTAInput
							type="number"
							label="CVC"
							maxlength="4"
							placeholder="3 or 4 digit number"
							bind:value={cc_cvc}
							bind:change_function={validate_cc_cvc}
							bind:validation_function={validate_cc_cvc}
							show_error={is_cc_cvc_valid === false}
							error_text={'Code must be a 3 or 4 digit number.'}
					/>
			</div>
	</div>
</div>

<style>
	.creditcardcontent {
			width: 100%;
			padding: 0px
	}
	.ff {
			padding: 10px;
			width: 100%;
	}
	:global(.ff .group) {
			padding: 0px;
	}
	.formrow {
			width: 100%;
			padding: 0px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
			.creditcardcontent {
					width: 100%;
					padding: 0px
			}
			.ff {
					padding: 0px;
					width: 100%;
			}
			.formrow {
					width: 100%;
					padding: 0px;
					display: flex;
					flex-direction: column;
			}
			
	}
</style>
